import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-450fcd75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-menu" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_submenu = _resolveComponent("el-submenu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.isCollapse)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "宇涵物流订单系统"))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_menu, {
      "default-active": _ctx.defaultValue,
      class: "el-menu-vertical",
      collapse: _ctx.isCollapse,
      "unique-opened": true,
      "background-color": "#0c2135",
      "text-color": "#b7bdc3",
      "active-text-color": "#0a60bd"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userMenus, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.id
          }, [
            (item.type === 1)
              ? (_openBlock(), _createBlock(_component_el_submenu, {
                  key: 0,
                  index: item.id + ''
                }, {
                  title: _withCtx(() => [
                    (item.icon)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(item.icon)
                        }, null, 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subitem) => {
                      return (_openBlock(), _createBlock(_component_el_menu_item, {
                        key: subitem.id,
                        index: subitem.id + '',
                        onClick: ($event: any) => (_ctx.handleMenuItemClick(subitem))
                      }, {
                        default: _withCtx(() => [
                          (subitem.icon)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: _normalizeClass(subitem.icon)
                              }, null, 2))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(subitem.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["index", "onClick"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["index"]))
              : (item.type === 2)
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 1,
                    index: item.id + ''
                  }, {
                    default: _withCtx(() => [
                      (item.icon)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: _normalizeClass(item.icon)
                          }, null, 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["index"]))
                : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["default-active", "collapse"])
  ]))
}